import Joi from 'joi';

export const linkToOfferSchema = Joi.object({
  vendor: Joi.object().required().messages({
    'object.base': 'Vendor is required',
    'any.required': 'Vendor is required',
  }),
  service: Joi.object().required().messages({
    'object.base': 'Service is required',
    'any.required': 'Service is required',
  }),
  offer: Joi.object().required().messages({
    'object.base': 'Offer is required',
    'any.required': 'Offer is required',
  }),
  fullName: Joi.string().allow('').messages({
    'string.base': 'Full name must be a string',
  }),
  email: Joi.string().email({ tlds: { allow: false } }).allow('').messages({
    'string.email': 'Email must be a valid email address',
  }),
  phoneNumber: Joi.string().allow('').messages({
    'string.base': 'Phone number must be a string',
  }),
});

// Usage:
// const { error } = linkToOfferSchema.validate(state);
// if (error) { /* handle validation error */ }
